export default __webpack_public_path__ + "static/media/hht2_ep18_speaking_02.bf3db1bf.png";